module.exports = __webpack_public_path__ + "static/img/about2.210f7347.png";